// src/pages/usa/OregonCoast.js
import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateBooking from "../../components/affiliate/AffiliateBooking";   // ⭐ REQUIRED
import AffiliateExpedia from "../../components/affiliate/AffiliateExpedia";   // ⭐ REQUIRED
import AffiliateTrip from "../../components/affiliate/AffiliateTrip";   // ⭐ REQUIRED
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Oregon Coast ALWAYS goes back to Oregon map
export const backRoute = "/map/oregon";

export default function OregonColumbiaRiver() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__oregonColumbiaBackRouteSet) {
      window.__oregonColumbiaBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Oregon / Columbia River</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Oregon</h2>


            <p>
  This time I will focus on the <strong>Columbia River Gorge</strong> — a stunning region
  filled with waterfalls, hiking trails, and breathtaking views. The Columbia River forms much of the
  border between Oregon and Washington, and the gorge itself was carved over millions of years. It is
  a must‑visit destination for nature lovers and outdoor enthusiasts.
</p>

<p>
  I will share my experience about the places I was able to visit during this day. Sadly, I couldn’t
  explore everything I had planned. The rain was much frecuent than what I experienced on the coast,
  and since I don’t know the area well, I didn’t want to risk hiking deeper into the trails with the
  possibility of flooding or unsafe conditions. Safety first. I will definitely return to visit the
  rest of the waterfalls and trails, and I will update this review with more details and videos.
</p>


            {/* GETTING THERE */}
            <h3>🚗 Getting There</h3>

            <p>
              Getting to Oregon depends on where you are coming from and what kind of trip you are
              planning. Some people drive in from neighboring states, especially along the coast
              road, which is full of stunning views and hidden spots.
            </p>

            <p>
              I flew into Portland International Airport (PDX), rented a car through Dollar, and
              stayed at the Best Western Plus Portland Airport Hotel and Suites. It was convenient,
              close to the airport, easy to get in and out. From there, I drove to the Columbia 
              River Gorge, which is about a 30‑40 minute drive east of Portland using I‑84. 
              The drive itself is beautiful, with the river on one side and the mountains on the other.
            </p>

            {/* PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Historic Columbia River Highway:</strong> I want to do justice to this
                  place, but honestly, no words, descriptions, pictures, or videos can truly capture
                  it. Go early, do not rush, and enjoy the drive, the waterfalls and hikes. Some are short,
                  some are long, but all of them are absolutely worth it.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Multnomah Falls:</strong> This is the most famous waterfall in the area, and 
for good reason. It is stunning, easily accessible, and has a great trail that takes you 
to the top. The view from the bridge is iconic, and the hike to the top is rewarding. 
I went early to avoid crowds and to have a more peaceful experience.

<br />
At the base of the falls is the historic <strong>Multnomah Falls Lodge</strong>, 
built in <strong>1925</strong>. The lodge was created to serve travelers exploring the 
newly completed Historic Columbia River Highway. Its purpose was to offer a warm place 
to rest, eat, and learn about the area — and it still serves that role today.
<br />
Inside the lodge, there is a small <strong>gift shop</strong> and a U.S. Forest 
Service information center. The gift shop was originally intended to support the lodge 
and promote local artisans, offering books, postcards, and Northwest‑themed souvenirs 
for visitors. 
                  <a
                    href="https://www.google.com/maps?q=45.57760693770168,-122.1176674441438"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Multnomah Falls — View on Google Maps
                  </a>
                  <br />
                  </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Wahkeena Falls, Lemmons View Point, Fairy Falls:</strong> I love the hike
                  from the parking area to Wahkeena and Lemmons View Point. Wahkeena is smaller than
                  Multnomah but still worth the hike. The trail to Lemmons View Point gives you a
                  priceless view of the valley, the highway, and nature from above. Fairy Falls is
                  more like a stream of water, but still part of the experience.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.573873198099385,-122.1269359599106"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Wahkeena Falls — View on Google Maps
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.57413892980126,-122.12666585061132"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Lemmons View Point — View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Bridal Veil Falls and Latourell Falls:</strong> Both are short hikes.
                  Latourell is much shorter than Bridal Veil, but both are beautiful. I was more
                  impressed with Latourell — you can feel the cold water spraying your face and
                  body, and you can walk close to the waterfall. Definetly a refreshing experience, especially
                   on a hot day. T
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.554523000380684,-122.18034880815105"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Bridal Veil Falls — View on Google Maps
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.53872321746532,-122.21794030332717"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Latourell Falls — View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            {/* HIDDEN GEMS */}
            <h3>🌲 Hidden Gem</h3>

            <p>
              There are many places I still want to visit on my next trip to Oregon. Beacon Rock
              Peak, Tunnel Falls, Twister Falls, and Punch Bowl Falls are all part of one hike
              along the Eagle Creek Trail.
            </p>

            <ul>
                <li>
                <div className="place-block">
                  <strong>Tunnel Falls:</strong>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.58489,-121.85199"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Tunnel Falls — View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Twister Falls:</strong>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.58198,-121.85197"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Twister Falls — View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Punch Bowl Falls:</strong>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=45.62163,-121.89466"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Punch Bowl Falls — View on Google Maps
                  </a>
                </div>
              </li>

              
             
            </ul>

            {/* PLACES TO STAY */}
           <h3>🛏️ Places to Stay in Portland & Columbia River Gorge</h3>

<p>
  Whether you're staying in downtown Portland, near the airport for convenience, or
  exploring the Columbia River Gorge, there are excellent options in each area. All
  the hotels listed below are active and available on major platforms like Expedia
  and Booking.com.
</p>

<ul>

  {/* ⭐ PORTLAND DOWNTOWN */}
  <li>
    <div className="place-block">
      <strong>The Nines, Portland (Downtown):</strong> Luxury hotel in the heart of
      downtown Portland. Known for its rooftop dining and upscale atmosphere.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hotel Lucia (Downtown):</strong> Stylish boutique hotel with artful
      interiors and a central location. Great for walking the city.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Kimpton Hotel Monaco Portland (Downtown):</strong> Vibrant, pet‑friendly,
      and perfectly located for exploring the city.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  {/* ⭐ PORTLAND AIRPORT AREA */}
  <li>
    <div className="place-block">
      <strong>Best Western Plus Portland Airport Hotel & Suites:</strong> The one I
      stayed at — clean, quiet, and super convenient. Great service and easy access
      to the airport.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hyatt Place Portland Airport/Cascade Station:</strong> Modern, spacious,
      and located in a great shopping/dining area near the airport.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Country Inn & Suites by Radisson, Portland Airport:</strong> Comfortable,
      reliable, and close to both the airport and I‑205.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  {/* ⭐ COLUMBIA RIVER GORGE AREA */}
  <li>
    <div className="place-block">
      <strong>Columbia Gorge Hotel & Spa (Hood River):</strong> Historic hotel with
      river views, gardens, and a peaceful atmosphere.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Best Western Plus Hood River Inn:</strong> Waterfront hotel with great
      views and easy access to the Gorge.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Hampton Inn & Suites Hood River:</strong> Modern, clean, and perfectly
      located for exploring Multnomah Falls, Latourell Falls, and the Gorge.
      <em>Available on Expedia & Booking.com.</em>
    </div>
  </li>

</ul>

{/* AFFILIATE BLOCK */}
<h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
            <div className="affiliate-block">
              <AffiliateExpedia />
              <AffiliateBooking />
              <AffiliateTrip />
            </div>


            {/* VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>
              I took these videos from the Columbia River Highway, Oregon Coast, and Silver Falls
              State Park. Set the YouTube video quality to high resolution — I hope you enjoy them.
            </p>

            <p>
              <a
                href="https://youtu.be/sKY4QGH-_dc?si=3TuxLtHJJ1lxwWIB"
                target="_blank"
                rel="noopener noreferrer"
              >
                Columbia River Highway
              </a>
              <br />
              <a
                href="https://youtu.be/gnRiwn0G5M0?si=Pe6mMswPuAE0DvOq"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/RfD-5Sn4mkU?si=JqfA66NOIjw-Vn_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                Heceta Lighthouse
              </a>
              <br />
              <a
                href="https://youtu.be/eBihBb-C72Q?si=5d8e9BAcBVIzR9_E"
                target="_blank"
                rel="noopener noreferrer"
              >
                            Tunnel Beach
              </a>
              <br />
              <a
                href="https://youtu.be/dtBJI2IkvzQ?si=Nc3FDkqjuILq88Zn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Yaquina Lighthouse
              </a>
              <br />
               <a
                href="https://youtu.be/gnRiwn0G5M0?si=eFoVNkSpctkuaDlI"
                target="_blank"
                rel="noopener noreferrer"
              >
                Vista House at Crown Point
              </a>
              <br />
              <a
                href="https://youtu.be/9VtL3hw9HSQ?si=gNw1aZHo-5ACv47y"
                target="_blank"
                rel="noopener noreferrer"
              >
                Silver Falls State Park
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">

            <a
              href="https://youtu.be/sKY4QGH-_dc?si=ZtvO851uUAvKyXJ6"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/mm1.jpg"
                alt="Multnomah Falls Video"
              />
            </a>
             
            

            <a
              href="https://youtu.be/gnRiwn0G5M0?si=GTL7n6ljmHYrq0Nd"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/oregon/mm3.jpg"
                alt="Vista House Video"
              />
            </a>

            <img src="/images/usa/oregon/mm2.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm4.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm5.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm6.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm7.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm8.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm9.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm15.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm10.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm11.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm12.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm13.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm14.jpg" alt="Columbia River" />
            <img src="/images/usa/oregon/mm16.jpg" alt="Columbia River" />
           
           
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
